import React from 'react';
import PropTypes from 'prop-types';


import { connect } from 'react-redux';
import SiderAction from '../SiderAction';

import { Container } from './CustomizedGarage.styles';
import { colors } from '../../utils/variables.styles';
import { open } from '../../layout/components/Drawer/Drawer.reducer';
import {QuestionOutlined} from "@ant-design/icons";


// eslint-disable-next-line react/prefer-stateless-function
class CustomizedGarage extends React.Component {
  static propTypes = {
    openForm: PropTypes.node
  }

  static defaultProps = {
    openForm: null,
    translationsData: null,
  }

  render() {
    return (
      <div style={{ color: colors.primaryFontColor }}>
        <Container collapsed={this.props.collapsed} onClick={() => { this.props.openForm('contact'); }}>
          <SiderAction
            icon={<QuestionOutlined/>}
            collapsed={this.props.collapsed}
            pointer
            bottom
          >
           {this.props.translationsData.nonstandard_garage || 'nonstandard_garage'}
          </SiderAction>
        </Container>
      </div>
    );
  }
}

CustomizedGarage.propTypes = {
  collapsed: PropTypes.bool.isRequired
};

const mapDispatchToProps = {
  openForm: open
};

export default connect(null, mapDispatchToProps)(CustomizedGarage);
